import { useMutation, useQuery } from "@tanstack/react-query";
import api, { type ApiError } from "../api/http";
import type {
  InviteResolveResponse,
  JoinBusinessRequest,
  JoinBusinessResponse,
} from "../api/types";

/** Resolve a pending invitation token to public-safe details so the
 * "Join {business}" page can render before any account exists. Disabled until a
 * token is present; never retried so an invalid token surfaces immediately. */
export function useInviteResolve(token: string | null) {
  return useQuery<InviteResolveResponse, ApiError>({
    queryKey: ["invite-resolve", token],
    queryFn: () =>
      api.get<InviteResolveResponse>(`/api/v1/employees/invite/${token}/`),
    enabled: !!token,
    retry: false,
  });
}

/** Single-step employee join: creates the invitee's account (inactive until
 * email verified) and links them to the business with the invited role. */
export function useJoinBusiness() {
  return useMutation<JoinBusinessResponse, ApiError, JoinBusinessRequest>({
    mutationFn: (data) =>
      api.post<JoinBusinessResponse>("/api/v1/employees/join/", data),
  });
}
